import _sfc_main from "./Badge.vue2.js";
/* empty css           */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const Badge = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-62213f7e"]]);
export {
  Badge as default
};
//# sourceMappingURL=Badge.vue.js.map
